import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthorizationModule } from '@wilson/authorization';
import {
  Activity,
  RoleAction,
  RolePermissionSubject,
  Shift,
} from '@wilson/interfaces';
import { AssignShiftHelperService } from '@wilson/non-domain-specific/shift-helpers/core';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { AbilityServiceSignal } from '@casl/angular';
@Component({
  selector: 'wilson-assign-single-shift-action',
  imports: [TranslatePipe, NzTooltipModule, NzMenuModule, AuthorizationModule],
  templateUrl: './assign-single-shift-action.component.html',
  styleUrl: './assign-single-shift-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignSingleShiftActionComponent {
  private readonly assignShiftHelperService = inject(AssignShiftHelperService);

  @Input({
    required: true,
  })
  disableAssignShift = false;

  @Input({
    required: true,
  })
  shift!: Shift & { activities: Activity[] };

  @Output() assignShiftSuccess = new EventEmitter();

  protected RoleAction = RoleAction;
  protected RolePermissionSubject = RolePermissionSubject;
  protected can = inject(AbilityServiceSignal).can;

  async assignShift(): Promise<void> {
    const userId = await this.assignShiftHelperService.assignShifts([
      this.shift,
    ]);
    if (userId) {
      await this.assignShiftHelperService.updateShifts([this.shift], userId);
      this.assignShiftSuccess.emit();
    }
  }
}
